import { render, staticRenderFns } from "./FormSettingModal.vue?vue&type=template&id=e70bfeee&scoped=true"
import script from "./FormSettingModal.vue?vue&type=script&lang=js"
export * from "./FormSettingModal.vue?vue&type=script&lang=js"
import style0 from "./FormSettingModal.vue?vue&type=style&index=0&id=e70bfeee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70bfeee",
  null
  
)

export default component.exports